module.exports = __webpack_public_path__ + "img/21.b1b86599.png";